import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import * as tokenManager from '@/utils/tokenManager'

export const useAuthStore = defineStore('auth', () => {
  // 用户信息
  const userInfo = ref(tokenManager.getUserInfo())
  
  // token 响应式引用
  const token = ref(tokenManager.getToken())

  // 是否已登录
  const isLoggedIn = computed(() => {
    return !!token.value && !!userInfo.value
  })

  /**
   * 设置用户信息（登录时调用）
   * @param {Object} user - 用户信息对象
   */
  function setUserInfo(user) {
    userInfo.value = user
    tokenManager.saveUserInfo(user)
  }

  /**
   * 设置token（登录时调用）
   * @param {string} token - JWT token
   */
  function setToken(newToken) {
    token.value = newToken
    tokenManager.saveToken(newToken)
  }

  /**
   * 登出
   */
  function logout() {
    userInfo.value = null
    token.value = null
    tokenManager.clearAuthData()
  }

  /**
   * 更新用户信息
   * @param {Object} updates - 要更新的用户信息
   */
  function updateUserInfo(updates) {
    if (userInfo.value) {
      userInfo.value = { ...userInfo.value, ...updates }
      tokenManager.saveUserInfo(userInfo.value)
    }
  }

  /**
   * 获取用户ID
   */
  const userId = computed(() => userInfo.value?.user_id)

  /**
   * 获取用户电话
   */
  const phone = computed(() => userInfo.value?.phone)

  /**
   * 获取用户昵称
   */
  const nickname = computed(() => userInfo.value?.nickname)

  /**
   * 获取用户公司
   */
  const company = computed(() => userInfo.value?.company)

  /**
   * 获取用户类型
   */
  const userType = computed(() => userInfo.value?.user_type)

  return {
    userInfo,
    isLoggedIn,
    userId,
    phone,
    nickname,
    company,
    userType,
    setUserInfo,
    setToken,
    logout,
    updateUserInfo
  }
})
